import districtSeoData from './districtSeoData.json';

export const districtSeo = districtSeoData;

const defaultFailureScenarios = [
  'Kepenk motoru ses çıkarıyor ama hareket etmiyor',
  'Kepenk kapanırken rayda sürtme veya sıkışma oluyor',
  'Kumanda basıyor fakat alıcı kart tepki vermiyor',
  'Dükkan kepengi açılış veya kapanış saatinde yarıda kalıyor'
];

const defaultServiceSteps = [
  'Arıza belirtisi, mahalle ve kepengin açık/kapalı durumu telefon veya WhatsApp üzerinden alınır.',
  'Ekip, motor, ray, kumanda, alıcı kart ve manuel açma sistemini yerinde kontrol eder.',
  'Tamir, ayar veya parça değişimi gerekiyorsa işlem öncesinde net bilgi ve fiyat paylaşılır.',
  'Kepenk test edilerek güvenli açma-kapama, limit ayarı ve kumanda kontrolü tamamlanır.'
];

const buildFallbackFaqs = (name) => [
  {
    question: `${name} kepenk tamiri için servis veriyor musunuz?`,
    answer: `Evet. ${name} genelinde otomatik kepenk motoru, ray, kumanda, kart ve mekanik arızalar için servis veriyoruz.`
  },
  {
    question: `${name} bölgesinde acil kepenk servisi var mı?`,
    answer: '7/24 servis hattı üzerinden arıza ve mahalle bilgisi alınır, kepengin güvenli kapanması için uygun yönlendirme yapılır.'
  },
  {
    question: `${name} kepenk tamiri fiyatı nasıl belirlenir?`,
    answer: 'Fiyat; arızanın türü, kepenk ölçüsü, parça ihtiyacı ve işçilik süresine göre yerinde tespit sonrası netleşir.'
  },
  {
    question: `${name} için periyodik kepenk bakımı yapıyor musunuz?`,
    answer: 'Evet. Ray temizliği, motor kontrolü, kumanda-alıcı testi, bağlantı elemanları ve manuel açma sistemi kontrol edilir.'
  }
];

export const topSeoDistricts = [
  'beyoglu',
  'beylikduzu',
  'gungoren',
  'fatih',
  'besiktas',
  'sultangazi',
  'arnavutkoy',
  'bayrampasa',
  'umraniye',
  'kadikoy'
];

export const districtSeoSlugs = Object.keys(districtSeoData);

export const getDistrictSeo = (slug, districtData = {}) => {
  const seo = districtSeoData[slug] || {};
  const fallbackName =
    seo.name ||
    districtData.name ||
    districtData.title?.split(' ')[0] ||
    slug;
  const neighborhoods =
    seo.priorityNeighborhoods ||
    districtData.neighborhoods ||
    [];
  const primaryNeighborhood = neighborhoods[0] || fallbackName;

  return {
    ...seo,
    name: fallbackName,
    h1: seo.h1 || `${fallbackName} Kepenk Tamiri ve 7/24 Servis`,
    metaTitle:
      seo.metaTitle ||
      `${fallbackName} Kepenk Tamiri | 7/24 Kepenk Servisi`,
    metaDescription:
      seo.metaDescription ||
      `${fallbackName} ve çevresinde otomatik kepenk tamiri. Motor, kumanda, ray ve kart arızaları için hızlı servis.`,
    targetKeywords:
      seo.targetKeywords ||
      [
        `${fallbackName.toLocaleLowerCase('tr-TR')} kepenk tamiri`,
        `${fallbackName.toLocaleLowerCase('tr-TR')} kepenk servisi`,
        `${fallbackName.toLocaleLowerCase('tr-TR')} otomatik kepenk`
      ],
    priorityNeighborhoods: neighborhoods,
    commonFailures: seo.commonFailures || defaultFailureScenarios,
    serviceSteps: seo.serviceSteps || defaultServiceSteps,
    uniqueFaqs: seo.uniqueFaqs || districtData.faqs || buildFallbackFaqs(fallbackName),
    localAngle:
      seo.localAngle ||
      `${fallbackName} işletmeleri için kepenk arızalarında hızlı tespit, güvenli kapatma ve garantili servis yaklaşımı uygulanır.`,
    commercialContext:
      seo.commercialContext ||
      `${fallbackName} bölgesindeki cadde mağazaları, site altı dükkanlar, depolar ve küçük işletmeler için hizmet verilir.`,
    coverageCopy:
      seo.coverageCopy ||
      `${primaryNeighborhood} başta olmak üzere ${fallbackName} genelindeki mahallelere otomatik kepenk tamiri ve bakım servisi sağlanır.`,
    intro:
      seo.intro ||
      `${fallbackName} kepenk tamiri için motor, kumanda, ray, alıcı kart ve manuel açma arızalarına yerinde çözüm sunuyoruz.`,
    nearbyDistrictLinks: seo.nearbyDistrictLinks || [],
    whatsappMessage:
      seo.whatsappMessage ||
      `Merhaba, ${fallbackName}/${primaryNeighborhood} bölgesinde kepenk arızası var. Servis ve fiyat bilgisi almak istiyorum.`
  };
};

export const getDistrictSeoName = (slug) => districtSeoData[slug]?.name || slug;
